if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.sectionId = this.dataset.sectionId

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // 获取选中的配件。赠品与主商品必须在同一个 /cart/add.js 请求中提交，
        // 这样 Shopify Buy X Get Y 会在一次购物车计算里同时看到 X 和 Y。
        const allChecked = document.querySelectorAll(
          `#ProductInfo-${this.sectionId} accessory-list input[type="checkbox"]:checked`
        );

        const executeRequests = async () => {
          try {
            const formData = new FormData(this.form);
            const mainVariantId = String(formData.get('id') || '');
            const mainQuantity = Number(formData.get('quantity') || 1);

            const uniqueAccessoryIds = [...new Set(
              Array.from(allChecked)
                .map(item => String(item.value || ''))
                .filter(id => id && id !== mainVariantId)
            )];

            const mainItem = { id: mainVariantId, quantity: mainQuantity };
            const properties = {};
            for (const [key, value] of formData.entries()) {
              const match = key.match(/^properties\[(.*)\]$/);
              if (match && value !== '') properties[match[1]] = value;
            }
            if (Object.keys(properties).length) mainItem.properties = properties;
            if (formData.get('selling_plan')) mainItem.selling_plan = formData.get('selling_plan');

            // Shopify Cart Drawer 通常按“最近加入”优先显示。
            // 因此赠品放前、主商品放最后提交：折扣仍在同一次请求计算，
            // 但抽屉中主商品会保持在赠品之前。
            const items = [
              ...uniqueAccessoryIds.map(id => ({ id, quantity: 1 })),
              mainItem
            ];

            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.headers['Content-Type'] = 'application/json';

            const payload = { items };
            if (this.cart) {
              payload.sections = this.cart.getSectionsToRender().map(section => section.id);
              payload.sections_url = window.location.pathname;
              this.cart.setActiveElement(document.activeElement);
            }
            config.body = JSON.stringify(payload);

            const result = await fetch('/cart/add.js', config).then(response => response.json());
            if (result.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainVariantId,
                errors: result.errors || result.description,
                message: result.message,
              });
              this.handleErrorMessage(result.description || result.message);
              this.error = true;
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: mainVariantId,
                cartData: result,
              });
            }

            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => this.cart.renderContents(result));
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(result);
            }
          } catch (e) {
            console.error(e);
          } finally {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          }
        };
        executeRequests();
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
